var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-expand-icon lucide-expand",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15 15 6 6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15 9 6-6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16v5h-5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 8V3h-5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 16v5h5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m3 21 6-6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8V3h5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9 3 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.0c65c49ab9d31271ce3b30559526b405.svg";
export { ForwardRef as ReactComponent };